import React, { FC } from 'react'
import { LinkComponent, i18n, UISizes, UITypes } from 'LibNeo'
import { Callback } from 'Src/types/utilTypes'
import {
	LabelWrapper,
	RequiredIcon,
	Wrapper,
	Icon,
} from 'LibNeo/components/Basic/Label/TooltipLabel/styled'

export interface TooltipLabelComponentProps {
	title?: string
	required?: boolean
	tooltip?: string
	link?: string
	href?: string
	// TODO nc-5191
	linkAction?: Callback
}

export const TooltipLabelComponent: FC<TooltipLabelComponentProps> = ({
	title,
	required,
	tooltip,
	link,
	linkAction,
	href,
}): JSX.Element | null => {
	const label = title ? i18n(title) : null
	const iconTooltip = tooltip ? i18n(tooltip) : null
	return (
		Boolean(title || tooltip || link) && (
			<Wrapper>
				{Boolean(label) && (
					<LabelWrapper>
						{label}
						{required && <RequiredIcon>*</RequiredIcon>}
					</LabelWrapper>
				)}
				{Boolean(iconTooltip) && (
					<Icon type={UITypes.PASSIVE} name="help" tooltip={iconTooltip} size={UISizes.SMALL} />
				)}
				{Boolean(link) && (
					<LinkComponent title={link} onClick={linkAction} url={href} size={UISizes.SMALL} />
				)}
			</Wrapper>
		)
	)
}
